import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RemoteDiagnosticsVddGenericStructure } from '@vi-iot/client';

@Component({
  selector: 'app-vdd-mac-address-readonly',
  templateUrl: './vdd-mac-address-readonly.component.html',
  styleUrls: ['./vdd-mac-address-readonly.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddMacAddressReadonlyComponent {
  @Input() structureArray: RemoteDiagnosticsVddGenericStructure[];
}
